"use strict";

exports.__esModule = true;
var _CreateDashboardWizard = require("./CreateDashboardWizard");
Object.keys(_CreateDashboardWizard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateDashboardWizard[key]) return;
  exports[key] = _CreateDashboardWizard[key];
});
var _CreateDashboardScreen = require("./CreateDashboardScreen");
Object.keys(_CreateDashboardScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateDashboardScreen[key]) return;
  exports[key] = _CreateDashboardScreen[key];
});
var _Dashboard = require("./Dashboard");
Object.keys(_Dashboard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Dashboard[key]) return;
  exports[key] = _Dashboard[key];
});
var _DashboardThumbnail = require("./DashboardThumbnail");
Object.keys(_DashboardThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardThumbnail[key]) return;
  exports[key] = _DashboardThumbnail[key];
});
var _DashboardCollection = require("./DashboardCollection");
Object.keys(_DashboardCollection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardCollection[key]) return;
  exports[key] = _DashboardCollection[key];
});
var _DashboardDataProvider = require("./DashboardDataProvider");
Object.keys(_DashboardDataProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardDataProvider[key]) return;
  exports[key] = _DashboardDataProvider[key];
});
var _DashboardEditor = require("./DashboardEditor");
Object.keys(_DashboardEditor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardEditor[key]) return;
  exports[key] = _DashboardEditor[key];
});
var _DashboardList = require("./DashboardList");
Object.keys(_DashboardList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardList[key]) return;
  exports[key] = _DashboardList[key];
});
var _DashboardListScreen = require("./DashboardListScreen");
Object.keys(_DashboardListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardListScreen[key]) return;
  exports[key] = _DashboardListScreen[key];
});
var _DashboardNavbar = require("./DashboardNavbar");
Object.keys(_DashboardNavbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardNavbar[key]) return;
  exports[key] = _DashboardNavbar[key];
});
var _DashboardRoutes = require("./DashboardRoutes");
Object.keys(_DashboardRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardRoutes[key]) return;
  exports[key] = _DashboardRoutes[key];
});
var _DashboardScreen = require("./DashboardScreen");
Object.keys(_DashboardScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardScreen[key]) return;
  exports[key] = _DashboardScreen[key];
});
var _DashboardURLFilter = require("./DashboardURLFilter");
Object.keys(_DashboardURLFilter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardURLFilter[key]) return;
  exports[key] = _DashboardURLFilter[key];
});
var _UpdateDashboardScreen = require("./UpdateDashboardScreen");
Object.keys(_UpdateDashboardScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateDashboardScreen[key]) return;
  exports[key] = _UpdateDashboardScreen[key];
});
var _getDashboardWidgets = require("./getDashboardWidgets");
Object.keys(_getDashboardWidgets).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDashboardWidgets[key]) return;
  exports[key] = _getDashboardWidgets[key];
});
var _DashboardToolbar = require("./DashboardToolbar");
Object.keys(_DashboardToolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardToolbar[key]) return;
  exports[key] = _DashboardToolbar[key];
});
var _DashboardTagContext = require("./DashboardTagContext");
Object.keys(_DashboardTagContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardTagContext[key]) return;
  exports[key] = _DashboardTagContext[key];
});